function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.967
    },
    fill: "#000000",
    d: "M 139.5,15.5 C 173.762,13.8847 207.762,16.0513 241.5,22C 257.29,25.1519 272.29,30.4852 286.5,38C 294.111,42.278 299.611,48.4446 303,56.5C 303.5,112.166 303.667,167.832 303.5,223.5C 348.501,223.333 393.501,223.5 438.5,224C 446.667,226.833 452.167,232.333 455,240.5C 455.333,279.833 455.667,319.167 456,358.5C 463.667,389.167 471.333,419.833 479,450.5C 479.667,459.833 479.667,469.167 479,478.5C 476.649,485.519 472.149,490.686 465.5,494C 422.225,495.159 378.891,495.659 335.5,495.5C 292.109,495.659 248.775,495.159 205.5,494C 198.851,490.686 194.351,485.519 192,478.5C 191.333,469.167 191.333,459.833 192,450.5C 198.94,422.241 206.106,394.075 213.5,366C 188.881,367.451 164.215,367.785 139.5,367C 112.337,365.64 86.0034,360.307 60.5,351C 51.5824,347.405 43.7491,342.238 37,335.5C 35.0797,332.661 33.4131,329.661 32,326.5C 31.3333,236.5 31.3333,146.5 32,56.5C 35.389,48.4446 40.889,42.278 48.5,38C 62.7103,30.4852 77.7103,25.1519 93.5,22C 108.894,19.2054 124.227,17.0387 139.5,15.5 Z M 165.5,31.5 C 195.667,31.4792 225.334,35.3126 254.5,43C 297.167,56.6667 297.167,70.3333 254.5,84C 196.505,99.3309 138.505,99.3309 80.5,84C 37.8333,70.3333 37.8333,56.6667 80.5,43C 108.5,35.6265 136.833,31.7932 165.5,31.5 Z M 47.5,88.5 C 65.3705,97.8898 84.3705,104.057 104.5,107C 146.5,113 188.5,113 230.5,107C 250.34,104.211 269.006,98.0442 286.5,88.5C 287.666,101.487 287.833,114.487 287,127.5C 286.269,129.899 285.102,132.065 283.5,134C 272.592,141.642 260.592,146.975 247.5,150C 202.771,159.784 157.771,161.451 112.5,155C 93.6446,152.454 75.6446,147.121 58.5,139C 53.2425,136.744 49.7425,132.91 48,127.5C 47.5001,114.504 47.3334,101.504 47.5,88.5 Z M 47.5,152.5 C 65.3705,161.89 84.3705,168.057 104.5,171C 146.5,177 188.5,177 230.5,171C 250.34,168.211 269.006,162.044 286.5,152.5C 287.666,165.487 287.833,178.487 287,191.5C 286.269,193.899 285.102,196.065 283.5,198C 272.592,205.642 260.592,210.975 247.5,214C 202.771,223.784 157.771,225.451 112.5,219C 93.6446,216.454 75.6446,211.121 58.5,203C 53.2425,200.744 49.7425,196.91 48,191.5C 47.5001,178.504 47.3334,165.504 47.5,152.5 Z M 216.5,237.5 C 215.714,252.802 215.214,268.135 215,283.5C 169.763,289.739 124.929,287.239 80.5,276C 70.3847,273.275 61.0513,268.941 52.5,263C 50.5704,260.742 49.0704,258.242 48,255.5C 47.1673,242.487 47.334,229.487 48.5,216.5C 56.5916,221.588 65.2583,225.421 74.5,228C 104.915,236.472 135.915,240.305 167.5,239.5C 183.871,239.583 200.204,238.916 216.5,237.5 Z M 285.5,216.5 C 287.344,218.279 288.01,220.612 287.5,223.5C 283.154,223.666 278.821,223.499 274.5,223C 278.56,221.311 282.227,219.144 285.5,216.5 Z M 239.5,239.5 C 303.501,239.333 367.501,239.5 431.5,240C 436,240.5 438.5,243 439,247.5C 439.5,282.165 439.667,316.832 439.5,351.5C 370.167,351.5 300.833,351.5 231.5,351.5C 231.333,316.832 231.5,282.165 232,247.5C 232.68,242.989 235.18,240.323 239.5,239.5 Z M 47.5,280.5 C 69.7736,291.822 93.4402,298.655 118.5,301C 150.818,304.154 183.151,304.321 215.5,301.5C 215.824,317.078 215.491,332.578 214.5,348C 169.353,353.725 124.686,351.058 80.5,340C 70.3847,337.275 61.0513,332.941 52.5,327C 50.5704,324.742 49.0704,322.242 48,319.5C 47.5001,306.504 47.3334,293.504 47.5,280.5 Z M 230.5,367.5 C 300.501,367.333 370.501,367.5 440.5,368C 447.555,394.385 454.221,420.885 460.5,447.5C 377.167,447.5 293.833,447.5 210.5,447.5C 216.858,420.733 223.525,394.067 230.5,367.5 Z M 207.5,463.5 C 292.833,463.5 378.167,463.5 463.5,463.5C 463.887,468.08 463.053,472.414 461,476.5C 459.352,477.717 457.519,478.55 455.5,479C 375.5,479.667 295.5,479.667 215.5,479C 211,478.5 208.5,476 208,471.5C 207.503,468.854 207.336,466.187 207.5,463.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 119.5,55.5 C 151.5,55.5 183.5,55.5 215.5,55.5C 215.5,60.8333 215.5,66.1667 215.5,71.5C 183.5,71.5 151.5,71.5 119.5,71.5C 119.5,66.1667 119.5,60.8333 119.5,55.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 63.5,111.5 C 68.8333,111.5 74.1667,111.5 79.5,111.5C 79.5,116.833 79.5,122.167 79.5,127.5C 74.1667,127.5 68.8333,127.5 63.5,127.5C 63.5,122.167 63.5,116.833 63.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 95.5,119.5 C 100.833,119.5 106.167,119.5 111.5,119.5C 111.5,124.833 111.5,130.167 111.5,135.5C 106.167,135.5 100.833,135.5 95.5,135.5C 95.5,130.167 95.5,124.833 95.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 127.5,127.5 C 132.833,127.5 138.167,127.5 143.5,127.5C 143.5,132.833 143.5,138.167 143.5,143.5C 138.167,143.5 132.833,143.5 127.5,143.5C 127.5,138.167 127.5,132.833 127.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 63.5,175.5 C 68.8333,175.5 74.1667,175.5 79.5,175.5C 79.5,180.833 79.5,186.167 79.5,191.5C 74.1667,191.5 68.8333,191.5 63.5,191.5C 63.5,186.167 63.5,180.833 63.5,175.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 95.5,183.5 C 100.833,183.5 106.167,183.5 111.5,183.5C 111.5,188.833 111.5,194.167 111.5,199.5C 106.167,199.5 100.833,199.5 95.5,199.5C 95.5,194.167 95.5,188.833 95.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 127.5,191.5 C 132.833,191.5 138.167,191.5 143.5,191.5C 143.5,196.833 143.5,202.167 143.5,207.5C 138.167,207.5 132.833,207.5 127.5,207.5C 127.5,202.167 127.5,196.833 127.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 63.5,239.5 C 68.8333,239.5 74.1667,239.5 79.5,239.5C 79.5,244.833 79.5,250.167 79.5,255.5C 74.1667,255.5 68.8333,255.5 63.5,255.5C 63.5,250.167 63.5,244.833 63.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 95.5,247.5 C 100.833,247.5 106.167,247.5 111.5,247.5C 111.5,252.833 111.5,258.167 111.5,263.5C 106.167,263.5 100.833,263.5 95.5,263.5C 95.5,258.167 95.5,252.833 95.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 127.5,255.5 C 132.833,255.5 138.167,255.5 143.5,255.5C 143.5,260.833 143.5,266.167 143.5,271.5C 138.167,271.5 132.833,271.5 127.5,271.5C 127.5,266.167 127.5,260.833 127.5,255.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 359.5,255.5 C 364.833,255.5 370.167,255.5 375.5,255.5C 375.5,276.833 375.5,298.167 375.5,319.5C 380.833,319.5 386.167,319.5 391.5,319.5C 391.5,324.833 391.5,330.167 391.5,335.5C 354.167,335.5 316.833,335.5 279.5,335.5C 279.5,330.167 279.5,324.833 279.5,319.5C 284.833,319.5 290.167,319.5 295.5,319.5C 295.5,308.833 295.5,298.167 295.5,287.5C 300.833,287.5 306.167,287.5 311.5,287.5C 311.5,298.167 311.5,308.833 311.5,319.5C 316.833,319.5 322.167,319.5 327.5,319.5C 327.5,303.5 327.5,287.5 327.5,271.5C 332.833,271.5 338.167,271.5 343.5,271.5C 343.5,287.5 343.5,303.5 343.5,319.5C 348.833,319.5 354.167,319.5 359.5,319.5C 359.5,298.167 359.5,276.833 359.5,255.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 63.5,303.5 C 68.8333,303.5 74.1667,303.5 79.5,303.5C 79.5,308.833 79.5,314.167 79.5,319.5C 74.1667,319.5 68.8333,319.5 63.5,319.5C 63.5,314.167 63.5,308.833 63.5,303.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 95.5,311.5 C 100.833,311.5 106.167,311.5 111.5,311.5C 111.5,316.833 111.5,322.167 111.5,327.5C 106.167,327.5 100.833,327.5 95.5,327.5C 95.5,322.167 95.5,316.833 95.5,311.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 127.5,319.5 C 132.833,319.5 138.167,319.5 143.5,319.5C 143.5,324.833 143.5,330.167 143.5,335.5C 138.167,335.5 132.833,335.5 127.5,335.5C 127.5,330.167 127.5,324.833 127.5,319.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 263.5,383.5 C 268.833,383.5 274.167,383.5 279.5,383.5C 279.5,388.833 279.5,394.167 279.5,399.5C 274.167,399.5 268.833,399.5 263.5,399.5C 263.5,394.167 263.5,388.833 263.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 295.5,383.5 C 300.833,383.5 306.167,383.5 311.5,383.5C 311.5,388.833 311.5,394.167 311.5,399.5C 306.167,399.5 300.833,399.5 295.5,399.5C 295.5,394.167 295.5,388.833 295.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 327.5,383.5 C 332.833,383.5 338.167,383.5 343.5,383.5C 343.5,388.833 343.5,394.167 343.5,399.5C 338.167,399.5 332.833,399.5 327.5,399.5C 327.5,394.167 327.5,388.833 327.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 359.5,383.5 C 364.833,383.5 370.167,383.5 375.5,383.5C 375.5,388.833 375.5,394.167 375.5,399.5C 370.167,399.5 364.833,399.5 359.5,399.5C 359.5,394.167 359.5,388.833 359.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 391.5,383.5 C 396.833,383.5 402.167,383.5 407.5,383.5C 407.5,388.833 407.5,394.167 407.5,399.5C 402.167,399.5 396.833,399.5 391.5,399.5C 391.5,394.167 391.5,388.833 391.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 247.5,415.5 C 258.167,415.5 268.833,415.5 279.5,415.5C 279.5,420.833 279.5,426.167 279.5,431.5C 268.833,431.5 258.167,431.5 247.5,431.5C 247.5,426.167 247.5,420.833 247.5,415.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 295.5,415.5 C 322.167,415.5 348.833,415.5 375.5,415.5C 375.5,420.833 375.5,426.167 375.5,431.5C 348.833,431.5 322.167,431.5 295.5,431.5C 295.5,426.167 295.5,420.833 295.5,415.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 391.5,415.5 C 402.167,415.5 412.833,415.5 423.5,415.5C 423.5,420.833 423.5,426.167 423.5,431.5C 412.833,431.5 402.167,431.5 391.5,431.5C 391.5,426.167 391.5,420.833 391.5,415.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataops);
export default __webpack_public_path__ + "static/media/Data ops.d0f44d4a641b7bb10e9f30d7d4822712.svg";
export { ForwardRef as ReactComponent };